import { useEffect, useState } from "react"

import { DRAWER_ID_SUFFIX } from "@/atoms"

import type { TabComponentProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"

export const useActiveTab = (
  id: string,
  data: unknown,
  props: TabComponentProps
) => {
  const [active, setActive] = useState<boolean>()

  useEffect(() => {
    const element = document
      .getElementById(`${props.drawerId}${DRAWER_ID_SUFFIX}`)
      ?.querySelector(`[data-node-key='${id}']`)

    if (!element) return

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "class" && !active)
          setActive(
            mutation.target instanceof HTMLElement &&
              mutation.target.classList.contains("ant-tabs-tab-active")
          )
      })
    })

    observer.observe(element, { attributes: true })

    if (
      element.classList.contains("ant-tabs-tab-active") &&
      active === undefined
    )
      setActive(true)

    return () => {
      observer.disconnect()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  return { active: active ?? false }
}
